// extracted by mini-css-extract-plugin
module.exports = {"village-mortgage-filter":"_93444fe79c--village-mortgage-filter--OZx9i"};